import { Component, OnInit, Input, ElementRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ModalComponent } from 'core/components/modal/modal.component';
import { JobsService } from 'core/services/jobs.service';
import { DynamicFormComponent, QuestionBase, DropdownQuestion } from 'core/components';

@Component({
  selector: 'lms-send-diploma-courses',
  templateUrl: './send-diploma-courses.component.html',
  styleUrls: ['./send-diploma-courses.component.scss']
})
export class SendDiplomaComponent implements OnInit {
  @Input() catalogueId: string;
  @Output() confirm = new EventEmitter<any>();
  @ViewChild(DynamicFormComponent, { static: false }) public dynamicForm: DynamicFormComponent;
  @ViewChild('ModalSendDiploma', { static: false }) public ModalSendDiploma: ModalComponent;
  @Input() selectedCourses: any;
  public diplomaQuestions: QuestionBase<any>[] = [];
  public defaultSendDiploma: boolean;

  constructor(
    public activatedRoute: ActivatedRoute,
    public translate: TranslateService,
    public elementRef: ElementRef,
    public jobsService: JobsService
  ) {}

  ngOnInit() {}

  sendDiploma(option) {
    const jobData = {
      jobType: this.jobsService.jobTypes.UPDATE_COURSE_CONFIG_BULK,
      courses: [...this.selectedCourses.keys()].map((id) => ({ id })),
      configuration: {
        shouldSendDiploma: option && option.sendDiploma === 'allSelected' ? true : false
      },
      catalogueId: this.catalogueId
    };
    this.confirm.emit(jobData);
    this.cancelModal();
  }

  openModal(selectedCourses, defaultSendDiploma) {
    this.defaultSendDiploma = defaultSendDiploma;
    this.selectedCourses = selectedCourses;
    this.newDropdownOptions();
    this.ModalSendDiploma.open();
  }

  cancelModal() {
    this.ModalSendDiploma.close();
  }

  newDropdownOptions() {
    this.diplomaQuestions = [
      new DropdownQuestion({
        key: 'sendDiploma',
        label: 'courses.diplomaSendInputLabel',
        options: [
          { key: 'allSelected', value: this.translate.instant('courses.allSelectedCourses') },
          { key: 'noSelected', value: this.translate.instant('courses.noSelecectedCourses') }
        ],
        value: this.defaultSendDiploma ? 'allSelected' : 'noSelected'
      })
    ];
  }

  public ngOnDestroy(): void {}
}
